/* global BigInt */
export const entryKinds = {
  credit: '充值入账',
  consume: '调用扣费',
  reserve: '预占',
  release: '释放预占',
  reconcile: '人工核算',
};
export function financeYuan(value = 0) {
  const amount = BigInt(String(value ?? 0));
  const negative = amount < 0n;
  const absolute = negative ? -amount : amount;
  const fraction = String(absolute % 1000000n)
    .padStart(6, '0')
    .replace(/0+$/, '')
    .padEnd(2, '0');
  return `¥${negative ? '-' : ''}${(absolute / 1000000n).toLocaleString(
    'zh-CN'
  )}.${fraction || '00'}`;
}
export function dateRange(days = 30) {
  const now = Date.now() + 8 * 3600000;
  return {
    from: new Date(now - (days - 1) * 86400000).toISOString().slice(0, 10),
    to: new Date(now).toISOString().slice(0, 10),
  };
}
export function financeQuery(filters) {
  const q = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === '') return;
    if (key === 'from' || key === 'to') {
      const seconds = Math.floor(
        Date.parse(
          value + (key === 'from' ? 'T00:00:00+08:00' : 'T23:59:59+08:00')
        ) / 1000
      );
      if (!Number.isFinite(seconds)) throw new Error('无效日期');
      q.set(key, String(seconds));
    } else q.set(key, String(value));
  });
  return q.toString();
}
